// Module
var code = "<button class=\"cell button\" d-org-id=\":orgId\"> <span class=\"icon is-small is-hidden\"> <i class=\"fa-solid fa-check\"></i> </span> <span>:orgName :baseCurrency</span> </button> ";
// Exports
export default code;